<script>
export default {
  name: 'WhatsappIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6532 7.60668C14.4265 3.74001 10.9132 0.760017 6.86653 1.42668C4.07986 1.88668 1.84654 4.14667 1.4132 6.93334C1.15987 8.54667 1.49322 10.0733 2.21988 11.3333L1.62654 13.54C1.49321 14.04 1.95319 14.4933 2.44653 14.3533L4.61987 13.7533C5.60653 14.3333 6.75987 14.6667 7.9932 14.6667C11.7532 14.6667 14.8732 11.3533 14.6532 7.60668ZM11.2532 10.48C11.1932 10.6 11.1199 10.7133 11.0265 10.82C10.8599 11 10.6799 11.1333 10.4799 11.2133C10.2799 11.3 10.0599 11.34 9.82653 11.34C9.48653 11.34 9.11986 11.26 8.73986 11.0933C8.3532 10.9267 7.97322 10.7067 7.59322 10.4333C7.20655 10.1533 6.84654 9.84001 6.49987 9.50001C6.15321 9.15334 5.84652 8.78666 5.56652 8.40666C5.29319 8.02666 5.0732 7.64667 4.9132 7.26667C4.7532 6.88667 4.67321 6.52001 4.67321 6.17335C4.67321 5.94668 4.71321 5.72668 4.79321 5.52668C4.87321 5.32001 4.99989 5.13335 5.17989 4.96668C5.39322 4.75335 5.62654 4.65335 5.8732 4.65335C5.96654 4.65335 6.05985 4.67334 6.14652 4.71334C6.23319 4.75334 6.3132 4.81334 6.3732 4.90001L7.14652 5.99333C7.20652 6.08 7.25319 6.15334 7.27986 6.22667C7.31319 6.3 7.32653 6.36667 7.32653 6.43334C7.32653 6.51334 7.29988 6.59335 7.25321 6.67335C7.20654 6.75335 7.14652 6.83334 7.06652 6.91334L6.81319 7.18C6.77319 7.22 6.75988 7.26001 6.75988 7.31334C6.75988 7.34001 6.76652 7.36667 6.77319 7.39334C6.78652 7.42 6.79321 7.44001 6.79988 7.46001C6.85988 7.57334 6.96653 7.71333 7.11319 7.88666C7.26653 8.06 7.42656 8.24 7.59989 8.41334C7.77989 8.59334 7.95321 8.75333 8.13321 8.90666C8.30655 9.05333 8.45319 9.15334 8.56652 9.21334C8.58652 9.22001 8.60654 9.23333 8.62654 9.24C8.65321 9.25333 8.67988 9.25334 8.71321 9.25334C8.77321 9.25334 8.81323 9.23335 8.85323 9.19335L9.10652 8.94001C9.19319 8.85334 9.27322 8.79334 9.34655 8.75334C9.42655 8.70668 9.49988 8.68 9.58654 8.68C9.65321 8.68 9.71987 8.69334 9.79321 8.72667C9.86654 8.76 9.94653 8.80001 10.0265 8.86001L11.1332 9.64667C11.2199 9.70667 11.2799 9.78001 11.3199 9.86001C11.3532 9.94668 11.3732 10.0267 11.3732 10.12C11.3332 10.2333 11.3065 10.36 11.2532 10.48Z"
      :fill="color"
    />
  </svg>
</template>
